module.exports = function(posts) {
	'use strict'
	posts.directive('usElectionDir',usElectionDir);
	usElectionDir.$inject=[];
	function usElectionDir() {
		return {
			template: require('./partial/usElection.html'),
			controller:'usElectionController',
			controllerAs:'vmue',
			link: function(scope, element, attrs, ctrl) {
				    
			}

		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/postsModule/usElection/js/directive/usElectionDirective.js
// module id = 572
// module chunks = 0